import { alertController } from '@ionic/vue';
import AlertConst from '../../constant/alert.constant';

let lockRequest = false;

const softRequestPermission = () => new Promise((resolve) => {
  if (!lockRequest) {
    lockRequest = true;
    alertController
      .create({
        header: AlertConst.permissionAlert.geoLocation.title,
        message: AlertConst.permissionAlert.geoLocation.message,
        buttons: [
          {
            text: 'No',
            handler() {
              resolve(false);
            },
          },
          {
            text: 'Yes',
            handler() {
              resolve(true);
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }
  setTimeout(() => {
    lockRequest = false;
  }, 1500);
});

export { softRequestPermission };
